/**
 * Created by andrey on 15.05.2026
 *
 * https://arkadiumsdk.z19.web.core.windows.net/docs/features/persistence
 * Use non-circular references when saving items on the remote storage, with a limit of 32KB per value.
 *
 */

class ArkadiumTransportAdapter {
    constructor() {
        this.bucketData = new BucketsTransportData(32);
    }

    saveData(data, options, onSuccess, onFailure) {
        let bucketsData = {};

        if (options.syncout) {
            bucketsData = this.bucketData.clearData();
        }

        bucketsData = Object.assign(bucketsData, this.bucketData.addData(data));

        bucketsData = SyncTransportUtils.serializeValues(bucketsData);

        const promises = Object.keys(bucketsData).map((key) => ArkadiumSDK.persistence.setRemoteStorageItem(key, bucketsData[key]));

        Promise.all(promises)
            .then(onSuccess)
            .catch(onFailure);
    }

    loadSession(onSuccess, onFailure) {
        const sessionBucketKey = this.bucketData.getSessionBucketKey();

        ArkadiumSDK.persistence.getRemoteStorageItem(sessionBucketKey)
            .then((value) => {
                let data = { [sessionBucketKey]: value };
                data = SyncTransportUtils.deserializeValues(data);
                data = this.bucketData.parseResponse(data);
                onSuccess(data && data.session);
            })
            .catch(onFailure);
    }

    loadData(onSuccess, onFailure) {
        const bucketKeys = this.bucketData.getAllBucketKeys();

        let data = {};

        const promises = bucketKeys.map((key) => ArkadiumSDK.persistence.getRemoteStorageItem(key).then((value) => {
            data[key] = value;
        }));

        Promise.all(promises)
            .then(() => {
                data = SyncTransportUtils.deserializeValues(data);

                this.bucketData.setData({ ...data });

                data = this.bucketData.parseResponse(data);
                onSuccess(data);
            })
            .catch(onFailure);
    }
}